export * from './dealer-type-config-add-edit.component';
export * from './dealer-type-config-list.component';
